<section class="app-top">
  <div class="hero">
    <video class="hero-media" autoplay [muted]="true" loop playsinline>
      <source [src]="imageUrl + config.heroVideoUrl" type="video/mp4" />
      Your browser does not support the video tag.
    </video>

    <div class="hero-content">
      <h1>
        {{ appModeService.isApp()
        ? ('APP.HERO_FALLBACK_TITLE' | translate)
        : (config.heroHeaderText || ('APP.HERO_FALLBACK_TITLE' | translate))
        }}
      </h1>

      <p>
        {{ appModeService.isApp()
        ? ('APP.HERO_FALLBACK_SUBTITLE' | translate)
        : (config.heroParagraphText || ('APP.HERO_FALLBACK_SUBTITLE' | translate))
        }}
      </p>

      <button type="button" routerLink="/products">
        {{ appModeService.isApp()
        ? ('APP.SHOP_NOW' | translate)
        : ('APP.SHOP_NOW' | translate)
        }}
      </button>
    </div>

  </div>

  <section class="app-categories">
    <div class="section-head">
      <span class="section-line"></span>
      <h2 class="section-title">{{ 'APP.PICK_A_CATEGORY' | translate }}</h2>
    </div>
    <div class="category-scroll">
      <button type="button" class="category-card" *ngFor="let category of categories; trackBy: trackByCategory"
        (click)="goToProductsByCategory(category.name)">
        <img [src]="getCategoryImage(category)" [alt]="category.name" draggable="false" loading="lazy" />
        <span>{{ category.name | uppercase }}</span>
      </button>
    </div>
  </section>

  <section class="app-catalogue">
    <div class="section-head centered">
      <span class="section-line"></span>
      <h2 class="section-title">
        {{ config.catalogueHeaderText || ('APP.CATALOGUE_SHOWCASE' | translate) }}
      </h2>
    </div>
    <p-carousel [value]="catalogueImages" [numVisible]="1" [numScroll]="1" [circular]="true" [showIndicators]="false"
      [showNavigators]="false" [responsiveOptions]="catalogueResponsiveOptions" styleClass="app-catalogue-carousel"
      dir="ltr">
      <ng-template pTemplate="item" let-image>
        <article class="catalogue-card">
          <img [src]="imageUrl + image" alt="Catalogue item" loading="lazy" />
        </article>
      </ng-template>
    </p-carousel>
  </section>

  <section class="app-promo-banner">
    <app-banner [config]="config"></app-banner>
  </section>

  <section class="app-clients-section">
    <div class="section-head centered">
      <span class="section-line"></span>
      <h2 class="section-title">{{ 'APP.OUR_CLIENTS' | translate }}</h2>
    </div>
    <app-client></app-client>
  </section>

  <section class="app-blog-section">
    <app-blog></app-blog>
  </section>

  <div class="app-filter-modal" *ngIf="isFilterOpen">
    <div class="app-filter-overlay" (click)="closeFilter()"></div>

    <section class="app-filter-sheet" (click)="$event.stopPropagation()">
      <header class="app-filter-sheet-header">
        <h2>{{ 'APP.FILTER_AND_SORT' | translate }}</h2>
        <button type="button" class="app-filter-close-btn" (click)="closeFilter()">
          <i class="pi pi-times"></i>
        </button>
      </header>

      <div class="app-filter-content">
        <div class="app-filter-group">
          <h3>{{ 'SORT_BY' | translate }}</h3>
          <div class="app-filter-select-wrap">
            <select [(ngModel)]="selectedSort">
              <option *ngFor="let option of sortOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
            <i class="pi pi-angle-right"></i>
          </div>
        </div>

        <div class="app-filter-group">
          <h3>{{ 'TYPE' | translate }}</h3>
          <div class="app-check-grid">
            <button type="button" class="app-check-item" *ngFor="let category of categories"
              [class.active]="selectedCategory === category.name"
              (click)="selectedCategory = selectedCategory === category.name ? '' : category.name">
              <span class="box"></span>
              <span class="label">{{ category.name }}</span>
            </button>
          </div>
        </div>

        <div class="app-filter-group">
          <h3>{{ 'COLOR' | translate }}</h3>
          <div class="app-color-grid">
            <button type="button" class="app-color-box" *ngFor="let color of colors" [ngStyle]="{ background: color }"
              [class.active]="selectedColors.includes(color)" [attr.aria-label]="'Toggle color ' + color"
              (click)="toggleColor(color)"></button>
          </div>
        </div>

        <div class="app-filter-group">
          <h3>{{ 'SIZE' | translate }}</h3>
          <div class="app-check-grid">
            <button type="button" class="app-check-item" *ngFor="let size of sizes"
              [class.active]="selectedSizes.includes(size)" (click)="toggleSize(size)">
              <span class="box"></span>
              <span class="label">{{ size }}</span>
            </button>
          </div>
        </div>
      </div>

      <footer class="app-filter-actions">
        <button type="button" class="apply-btn" (click)="applyFilters()">{{ 'APP.APPLY' | translate }}</button>
        <button type="button" class="clear-btn" (click)="clearFilters()">{{ 'APP.CLEAR' | translate }}</button>
      </footer>
    </section>
  </div>
</section>